import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getCurrentUser, updateUserProfile } from '../redux/slices/userSlice';

const ProfileSection = () => {
    const dispatch = useDispatch();
    const { userInfo, loading } = useSelector((state) => state.user);

    const [isEditing, setIsEditing] = useState(false);
    const [name, setName] = useState('');
    const [photo, setPhoto] = useState(null);
    const [preview, setPreview] = useState('');

    useEffect(() => {
        dispatch(getCurrentUser());
    }, [dispatch]);

    useEffect(() => {
        if (userInfo) {
            setName(userInfo.name || '');
            setPreview(userInfo.photo || '');
        }
    }, [userInfo]);

    const handleImageChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            setPhoto(file);
            setPreview(URL.createObjectURL(file));
        }
    };

    const handleSave = async () => {
        const formData = new FormData();
        if (name) formData.append('name', name);
        if (photo) formData.append('photo', photo);

        await dispatch(updateUserProfile(formData));
        setIsEditing(false);
    };

    const handleCancel = () => {
        setIsEditing(false);
        setName(userInfo.name || '');
        setPreview(userInfo.photo || '');
        setPhoto(null);
    };

    return (
        <div className="bg-custom-white p-6 rounded-lg border-2 shadow-md mb-6">
            <div className="flex items-center justify-between mb-4">
                <h2 className="text-xl font-semibold text-custom-blue">My Profile</h2>
                {!isEditing ? (
                    <p
                        onClick={() => setIsEditing(true)}
                        className="text-custom-blue cursor-pointer hover:underline"
                    >
                        Edit
                    </p>
                ) : (
                    <div className="flex gap-2">
                        <button
                            onClick={handleSave}
                            disabled={loading}
                            className="bg-custom-yellow text-white px-3 py-1 rounded-md text-sm"
                        >
                            {loading ? 'Saving...' : 'Save'}
                        </button>
                        <button
                            onClick={handleCancel}
                            className="bg-gray-300 text-gray-800 px-3 py-1 rounded-md text-sm"
                        >
                            Cancel
                        </button>
                    </div>
                )}
            </div>

            <hr className="bg-gray-300 border" />

            <div className="grid grid-cols-2 p-4 gap-4">
                {/* Name */}
                <div>
                    <label className="block text-sm text-gray-400">Name</label>
                    {isEditing ? (
                        <input
                            type="text"
                            value={name}
                            onChange={(e) => setName(e.target.value)}
                            className="text-lg border rounded-md p-1 w-full text-custom-blue"
                        />
                    ) : (
                        <p className="text-lg text-custom-blue">{userInfo?.name}</p>
                    )}
                </div>

                {/* Email */}
                <div>
                    <label className="block text-sm text-gray-400">Email</label>
                    <p className="text-lg text-custom-blue">{userInfo?.email}</p>
                </div>

                {/* Phone */}
                {/* <div>
                    <label className="block text-sm text-gray-400">Phone</label>
                    <p className="text-lg text-custom-blue">
                        — <a href="#" className="text-custom-blue">Click to Verify</a>
                    </p>
                </div> */}
                {/* Profile Image */}
                <div className="col-span-2 flex items-center gap-4">
                    {isEditing && (
                        <div>
                            <label className="block text-sm text-gray-400">Update Profile Image</label>
                            <input
                                type="file"
                                accept="image/*"
                                onChange={handleImageChange}
                                className="block text-sm text-gray-500"
                            />
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default ProfileSection;
